// This file is used for Applications API Service urls
export const APIUrl = {
  //Admin Panel APIS
  userInfoUrl: "User/GetUserByUserId",
  categoryallUrl: 'Product/GetCategorysByAll',
  categoryUrl: 'Product/GetCategorys',
  productUrl: 'Product/GetProductListByCategoryID?categoryId=',
  addcategoryUrl: 'Product/AddandUpdateCategory',
  subproducturl: 'Product/GetSubProduct?ProductID=',
  addproductUrl: 'Product/AddMultipleProducts',
  imageupload: 'Product/UploadProductImage',
  editdeleteproduct: 'Product/EditOrDeleteProduct',
  adddeletesubproduct: 'Product/AddSubProducts',
  editsubproduct: 'Product/EditSubProduct',
  allproduct: 'Product/GetProductListByAll?categoryId=',
  //END
  //Transaction APIS
  transaction: 'Transaction/ViewAllCardsAdmin',
  transactiondeatil: 'Transaction/ViewTransactionDetailAdmin?productId=',
  //END
  //Consumer List API
  consumerslistUrl: 'Consumers/GetAllConsumersList?alphabet=',
  // END 
  //User List API
  userlistUrl: 'User/GetAllUsersList?alphabet=',
  // END 
};